var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _circle15, _circle16, _circle17, _circle18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1680 730",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "matrix(0.873077 0.487583 -0.78755 0.61625 429.154 175.316)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "matrix(0.994947 -0.100399 0.322552 0.946552 263.797 71.2188)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "matrix(0.994947 -0.100399 0.322552 0.946552 440 282.121)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "matrix(0.994947 -0.100399 0.322552 0.946552 410.404 338.926)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "matrix(0.994947 -0.100399 0.322552 0.946552 576 145.121)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "matrix(0.061383 -0.998114 0.99741 0.07192 961.715 604.32)",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "matrix(0.322553 0.946552 -0.994947 0.100399 544.891 280.938)",
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "matrix(0.322553 0.946552 -0.994947 0.100399 1245.01 314.668)",
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "matrix(0.322553 0.946552 -0.994947 0.100399 989.111 172.809)",
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "matrix(0.322553 0.946552 -0.994947 0.100399 974.557 162.211)",
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "matrix(0.322553 0.946552 -0.994947 0.100399 861.078 260.352)",
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "matrix(-0.322553 -0.946552 0.994947 -0.100399 814.387 514.258)",
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "matrix(-0.322553 -0.946552 0.994947 -0.100399 995.66 552.828)",
    fill: "white"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "matrix(-0.322553 -0.946552 0.994947 -0.100399 1154.39 545.258)",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.6,
    rx: 0.6,
    ry: 0.6,
    transform: "matrix(-0.95101 -0.309159 0.561017 -0.827804 280.908 307.363)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.6,
    rx: 0.6,
    ry: 0.6,
    transform: "matrix(-0.95101 -0.309159 0.561017 -0.827804 601.275 539.539)",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.6,
    rx: 0.6,
    ry: 0.6,
    transform: "matrix(-0.95101 -0.309159 0.561017 -0.827804 250.141 326.566)",
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.6,
    rx: 0.6,
    ry: 0.6,
    transform: "matrix(-0.95101 -0.309159 0.561017 -0.827804 1553.78 554.305)",
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.6,
    rx: 0.6,
    ry: 0.6,
    transform: "matrix(-0.95101 -0.309159 0.561017 -0.827804 322.141 513.363)",
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.6,
    rx: 0.6,
    ry: 0.6,
    transform: "matrix(-0.95101 -0.309159 0.561017 -0.827804 1504.14 366.363)",
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.6,
    rx: 0.6,
    ry: 0.6,
    transform: "matrix(-0.95101 -0.309159 0.561017 -0.827804 1140.55 485.527)",
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.6,
    rx: 0.6,
    ry: 0.6,
    transform: "matrix(-0.95101 -0.309159 0.561017 -0.827804 108.141 433.363)",
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.6,
    rx: 0.6,
    ry: 0.6,
    transform: "matrix(-0.95101 -0.309159 0.561017 -0.827804 1285.14 263.363)",
    fill: "white"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.6,
    rx: 0.6,
    ry: 0.6,
    transform: "matrix(-0.95101 -0.309159 0.561017 -0.827804 1372.09 492.215)",
    fill: "white"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.6,
    rx: 0.6,
    ry: 0.6,
    transform: "matrix(-0.95101 -0.309159 0.561017 -0.827804 630.725 434.363)",
    fill: "white"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.6,
    rx: 0.6,
    ry: 0.6,
    transform: "matrix(-0.95101 -0.309159 0.561017 -0.827804 696.141 281.363)",
    fill: "white"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.6,
    rx: 0.6,
    ry: 0.6,
    transform: "matrix(-0.95101 -0.309159 0.561017 -0.827804 1343.31 263.105)",
    fill: "white"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.6,
    rx: 0.6,
    ry: 0.6,
    transform: "matrix(-0.95101 -0.309159 0.561017 -0.827804 320.141 360.363)",
    fill: "white"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.6,
    cy: 0.6,
    rx: 0.6,
    ry: 0.6,
    transform: "matrix(-0.95101 -0.309159 0.561017 -0.827804 1086.54 295.914)",
    fill: "white"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "matrix(-0.958827 0.28399 -0.613701 -0.789538 1308.95 468.746)",
    fill: "white"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "matrix(-0.958827 0.28399 -0.613701 -0.789538 1327.66 447.223)",
    fill: "white"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "matrix(-0.958827 0.28399 -0.613701 -0.789538 1469.98 192.406)",
    fill: "white"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "matrix(-0.958827 0.28399 -0.613701 -0.789538 586.887 448.488)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.2d37633d0cf2a700665dd56edfca58d2.svg";
export { ForwardRef as ReactComponent };